module.exports = __webpack_public_path__ + "static/media/vaccine-shot-1-news.c6ac0500.jpg";